<div id="game">
    <iframe width="100%" height="99%" frameBorder="0" [src]="urlSafe"></iframe>
    <button mat-mini-fab class="button1 float-right" (click)="exitgame()"><mat-icon>cancel</mat-icon></button>
</div>
